import React from 'react';
import { ListElemText, RoundStatus, useTranslation, DotsLoader } from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';

export const statusMapper = (result, roundId) => {
  const { Started, Finished, Upcoming } = RoundStatus;
  if (result.status === Upcoming) {
    return Upcoming;
  }
  if (result.roundId === roundId && result.status === Started) {
    return Started;
  }
  return Finished;
};

export const StatusRenderer = ({ result, status }) => {
  const t = useTranslation();

  const { Upcoming, Started } = RoundStatus;
  const { Soon } = globalTranslationKeys;

  if (status === Upcoming) {
    return (
      <ListElemText className='inner-lists-item-row-item-txt t-t-n' noTextTransform>
        {t(Soon)}
      </ListElemText>
    );
  }
  if (status === Started) {
    return (
      <ListElemText forSaving>
        <DotsLoader />
      </ListElemText>
    );
  }

  return (
    <ListElemText noTextTransform>
      {result.roundData && result.roundData.reduce((acc, current) => acc + current)}
    </ListElemText>
  );
};
